import "reflect-metadata";
import { lazy } from "react";
import { injectable, registry } from "tsyringe";
import { FeatureSetupDef, FeatureRootRoute, FeatureSetup } from "../../src/types/feature.types";
import { featurePaths } from "./constants/paths.constant";
import { version, name } from "./package.json";
import { FeatureToken } from "../../src/constants/di";

const CustomsListPage = lazy(() => import("./pages/CustomsList"));

@injectable()
@registry([{ token: FeatureToken, useClass: CustomsManagement }])
class CustomsManagement implements FeatureSetupDef {
    GetFeatureSetup(): FeatureSetup {
        return {
            version,
            namespace: name,
            featuresRoot: this.features,
            permissions: [],
            index: true
        };
    }
    
    private readonly features: FeatureRootRoute = {
        requiredPermissions: [],
        children: [
            {
                title: "Customs List",
                path: featurePaths.CustomsList,
                page: CustomsListPage
            }
        ]
    };
}
